export let dataProps = {
    id: 0,
    mode_name: '',
    show_tender_amount_field: false,
    linked_bank_account_id: null,
    e_payment_mode: false,
    default_payment_mode: false
}


// WEBPACK FOOTER //
// ./src/store/modules/paymentMode/properties.js